import useStartNewHpDeviceVersion, {
    IUseStartNewHpDeviceVersionOutput,
} from "./useStartNewHpDeviceVersion"
import { LCTOnlyDatasets } from "../../../../../constants/enums"

/**
 * Thin wrapper around useStartNewHpDeviceVersion — the only difference is
 * the dataset passed to the API (EB vs HP). All form data, types, and mappers
 * are shared.
 */
const useStartNewEbDeviceVersion = (
    deviceRef: string,
    attachmentUUID: string
): IUseStartNewHpDeviceVersionOutput =>
    useStartNewHpDeviceVersion(deviceRef, attachmentUUID, LCTOnlyDatasets.EB)

export default useStartNewEbDeviceVersion
